export const heroCover =
  "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20portrait%20of%20a%20reporter%20silhouette%20studying%20pinned%20photographs%20and%20paper%20documents%20on%20an%20evidence%20board%2C%20deep%20crimson%20and%20amber%20duotone%2C%20cinematic%20rim%20light%2C%20moody%20high%20contrast%2C%20grainy%20film%20texture%2C%20dark%20background%2C%20photojournalism%2C%20investigative%20dossier%20aesthetic&width=1000&height=1250&seq=hero-cover-0831&orientation=portrait";

export const statusTicker = [
  { label: "归档材料", value: "1,286", unit: "条" },
  { label: "拆解篇目", value: "47", unit: "篇" },
  { label: "累计核验", value: "93", unit: "处" },
  { label: "最近更新", value: "今日 09:40", unit: "" },
];

export const indexTypes = [
  {
    key: "shot",
    icon: "ri-file-image-line",
    name: "截图证据",
    count: "742 条",
    desc: "聊天记录、页面快照与后台数据留证",
    color: "primary",
  },
  {
    key: "audio",
    icon: "ri-disc-line",
    name: "录音片段",
    count: "216 段",
    desc: "关键对话与现场实况完整原声留证",
    color: "accent",
  },
  {
    key: "video",
    icon: "ri-clapperboard-line",
    name: "视频材料",
    count: "188 个",
    desc: "直播录屏与长短视频逐帧核验",
    color: "secondary",
  },
  {
    key: "doc",
    icon: "ri-file-list-3-line",
    name: "文件账目",
    count: "140 份",
    desc: "订单、报表与公开资料交叉比对",
    color: "primary",
  },
];

export const featured = [
  {
    id: "feat-1",
    kicker: "直播争议 · 综合复盘",
    title: "一次带货场次中，宣传话术与到货实价的对冲核查",
    desc: "以同场录屏、订单快照与官方报价单为基线，逐条比对 12 处宣称与实收差异，分歧点已标注出处与时间码。",
    date: "2026-09-05",
    meta: "材料 14 件",
    status: "石锤",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20flat%20lay%20of%20torn%20paper%20fragments%2C%20printed%20chat%20screenshots%20and%20audio%20waveform%20printouts%20pinned%20on%20a%20dark%20crimson%20evidence%20board%20with%20amber%20marker%20circles%20and%20annotations%2C%20investigative%20journalism%2C%20deep%20red%20amber%20palette%2C%20dramatic%20lighting%2C%20grainy%20film%20texture&width=1200&height=760&seq=feat-live-0831&orientation=landscape",
  },
  {
    id: "feat-2",
    kicker: "后台数据 · 存证分析",
    title: "一份被删聊天记录的时间戳逆向还原",
    desc: "通过导出备份与元数据指纹，重建被删除对话的时间线，关键转发节点与口径转折处均附截图留证。",
    date: "2026-09-03",
    meta: "材料 9 件",
    status: "实锤",
    image:
      "https://readdy.ai/api/search-image?query=silhouette%20of%20hands%20holding%20a%20smartphone%20whose%20glowing%20amber%20screen%20shows%20chat%20log%20evidence%2C%20blurred%20dark%20newsroom%20background%20with%20red%20accents%2C%20investigative%20magazine%20photography%2C%20moody%20high%20contrast%2C%20film%20grain&width=1200&height=760&seq=feat-chat-0831&orientation=landscape",
  },
  {
    id: "feat-3",
    kicker: "公开回应 · 逐条拆解",
    title: "澄清声明里 7 处与既有材料对不上的细节",
    desc: "把官方回应的每一条结论，反向映射到此前归档的截图与录音，标注一致、存疑与冲突三档结论。",
    date: "2026-08-29",
    meta: "材料 11 件",
    status: "存疑",
    image:
      "https://readdy.ai/api/search-image?query=desk%20laden%20with%20cassette%20recorder%2C%20old%20phone%2C%20printed%20transcripts%20and%20red%20tape%20markers%20under%20a%20warm%20amber%20desk%20lamp%2C%20noir%20investigation%20mood%2C%20deep%20red%20amber%20tones%2C%20editorial%20photography%2C%20film%20grain%2C%20dark%20background&width=1200&height=760&seq=feat-desk-0831&orientation=landscape",
  },
];

export const libraryItems = [
  {
    id: "lib-1",
    title: "社群回复截图组 · 前言与后语对比",
    category: "截图",
    status: "石锤",
    date: "09-05",
    stat: "4.2k 浏览",
    image:
      "https://readdy.ai/api/search-image?query=macro%20close%20up%20of%20printed%20screenshot%20collage%20with%20a%20red%20circled%20detail%20and%20amber%20highlighter%20marks%20on%20an%20evidence%20folder%2C%20editorial%20photography%2C%20deep%20red%20amber%20palette%2C%20dark%20background%2C%20film%20grain&width=800&height=520&seq=lib-shot-1&orientation=landscape",
  },
  {
    id: "lib-2",
    title: "某次连麦录音 · 完整 22 分钟原声",
    category: "录音",
    status: "实锤",
    date: "09-04",
    stat: "3.8k 浏览",
    image:
      "https://readdy.ai/api/search-image?query=vintage%20answering%20machine%20with%20glowing%20red%20REC%20light%20and%20reels%2C%20audio%20evidence%20concept%2C%20moody%20editorial%20product%20shot%2C%20amber%20and%20deep%20red%20tones%2C%20dark%20background%2C%20cinematic%20lighting&width=800&height=520&seq=lib-audio-1&orientation=landscape",
  },
  {
    id: "lib-3",
    title: "直播录屏片段 · 关键节点时间码",
    category: "视频",
    status: "石锤",
    date: "09-02",
    stat: "5.1k 浏览",
    image:
      "https://readdy.ai/api/search-image?query=video%20camera%20lens%20focused%20on%20a%20cork%20evidence%20board%20with%20pinned%20notes%2C%20bokeh%20amber%20lights%2C%20documentary%20investigation%2C%20deep%20red%20amber%20duotone%2C%20editorial%20photography%2C%20dark%20background&width=800&height=520&seq=lib-video-1&orientation=landscape",
  },
  {
    id: "lib-4",
    title: "订单快照与到手包裹对照组",
    category: "截图",
    status: "实锤",
    date: "08-30",
    stat: "2.9k 浏览",
    image:
      "https://readdy.ai/api/search-image?query=stack%20of%20paper%20folders%20with%20amber%20seal%20stamps%20and%20red%20evidence%20markers%20on%20a%20dark%20desk%2C%20noir%20editorial%2C%20deep%20red%20amber%20tones%2C%20high%20contrast%2C%20film%20grain&width=800&height=520&seq=lib-shot-2&orientation=landscape",
  },
  {
    id: "lib-5",
    title: "私信转发原文 · 时间与身份链",
    category: "截图",
    status: "存疑",
    date: "08-27",
    stat: "3.3k 浏览",
    image:
      "https://readdy.ai/api/search-image?query=magnifying%20glass%20over%20blurred%20printed%20timestamped%20conversation%20transcript%20under%20a%20warm%20desk%20lamp%2C%20investigation%20editorial%2C%20deep%20red%20amber%20palette%2C%20dark%20background%2C%20film%20grain&width=800&height=520&seq=lib-doc-1&orientation=landscape",
  },
  {
    id: "lib-6",
    title: "公开数据批量比对 · 差异标点图",
    category: "文件",
    status: "实锤",
    date: "08-24",
    stat: "1.7k 浏览",
    image:
      "https://readdy.ai/api/search-image?query=document%20scanner%20bed%20with%20a%20paper%20sheet%20glowing%20under%20red%20and%20amber%20light%2C%20evidence%20digitization%20concept%2C%20moody%20editorial%2C%20deep%20red%20amber%20tones%2C%20high%20contrast%2C%20film%20grain&width=800&height=520&seq=lib-file-1&orientation=landscape",
  },
];

export const libraryFilters = ["全部", "截图", "录音", "视频", "文件"];

export const timeline = [
  {
    id: "tl-1",
    date: "2026-08-18",
    time: "20:14",
    title: "首段关键录音流出并同步发出文字版",
    status: "石锤",
    summary: "录音文件与转写文字同日归档，转写对照原文逐字校验，无删减标注。",
    material: ["原声 22 分钟", "转写稿 8 页"],
  },
  {
    id: "tl-2",
    date: "2026-08-21",
    time: "09:02",
    title: "团队首次公开回应，称录音“不完整”",
    status: "存疑",
    summary: "回应指向录音完整性，但未提供同场全量版本；本栏已就完整性提出待补项。",
    material: ["回应声明截图", "待补材料清单"],
  },
  {
    id: "tl-3",
    date: "2026-08-26",
    time: "14:47",
    title: "后台数据截图组归档，时间链开始闭环",
    status: "实锤",
    summary: "多份页面快照时间戳互相印证，关键节点与既有截图一致，暂未发现冲突。",
    material: ["页面快照 6 张", "元数据指纹"],
  },
  {
    id: "tl-4",
    date: "2026-09-02",
    time: "11:30",
    title: "追加视频录屏，口径前后出现明显偏移",
    status: "反转",
    summary: "新片段中口径与此前记录产生明显冲突，本栏将其单列为存疑项并开放复核。",
    material: ["录屏片段", "逐帧对比表"],
  },
];

export const statusLevels = [
  {
    key: "stone",
    name: "石锤",
    tone: "red",
    desc: "多源材料互相印证、时间链完整，可交叉复核并锁定结论。",
  },
  {
    key: "proof",
    name: "实锤",
    tone: "amber",
    desc: "具备单源硬材料支撑且无明显冲突，可作事实参考基线。",
  },
  {
    key: "doubt",
    name: "存疑",
    tone: "gray",
    desc: "材料指向存在但完整性或关联性不足，需继续补证。",
  },
  {
    key: "flip",
    name: "反转",
    tone: "line",
    desc: "新证据与旧口径冲突，结论被重新标记并进入复核队列。",
  },
];

export const archiveTags = [
  { name: "八酱黑料实锤", count: "132", heat: 5 },
  { name: "直播话术比对", count: "98", heat: 4 },
  { name: "录音原声", count: "216", heat: 5 },
  { name: "聊天记录", count: "87", heat: 3 },
  { name: "后台截图", count: "64", heat: 3 },
  { name: "退货与订单", count: "51", heat: 2 },
  { name: "澄清回应拆解", count: "47", heat: 4 },
  { name: "账号与身份链", count: "33", heat: 2 },
];

export const aboutPoints = [
  "只归档可追溯来源的材料，无法溯源或来源单一的信息一律不标注为实锤。",
  "每条截图、录音、视频均在页内标注类别与核验状态，不混同不同等级的结论。",
  "涉及完整性问题与口径冲突的条目，统一归入「存疑」「反转」并开放复核。",
  "争议拆解坚持对事不对人，材料指向谁便列谁，不预设结论、不为凑数注水。",
];